<template lang="pug">
  b-modal#memberSummary(
    ref="memberSummary"
    :title='$t("ui.combine.member_summary")'
    centered
    no-fade
    no-close-on-backdrop
    ok-only
    size="xl"
    :busy="loading"
    @show="reset"
    @shown="shown")
    template(v-if="item")
      div.row
        div.col-sm-12.col-md-2.col-lg-2
          div.row
            div.col-sm-12.col-md-12.col-lg-12
              div.card.card-accent-info
                div.card-header
                  i.fas.fa-money-bill-wave
                  span.font-weight-bold(:title="$t('ui.turnover')") {{ $t("ui.turnover") }}
                  span.badge.badge-info.float-right {{ currentMonth }}
                div.card-body
                  div
                    div.text-value
                      h1(:class="$helpers.fontClassName(validTurnover)" :title="$n(validTurnover, 'currency')") {{ $n(validTurnover, 'currency') }}
          div.row
            div.col-sm-12.col-md-12.col-lg-12
              div.card.card-accent-info
                div.card-header
                  i.fas.fa-dollar-sign
                  span.font-weight-bold(:title="$t('ui.winlose')") {{ $t("ui.winlose") }}
                  span.badge.badge-info.float-right {{ currentMonth }}
                div.card-body
                  div
                    div.text-value
                      h1(:class="$helpers.fontClassName(winlose)" :title="$n(winlose, 'currency')") {{ $n(winlose, 'currency') }}
        div.col-sm-12.col-md-10.col-lg-10
          div.row
            div.col-sm-12.col-md-6.col-lg-4
              div.col-sm-12.col-md-12.col-lg-12
                b-form-group(:label="$t('deposit')")
                  table.tablex(width="100%")
                    thead
                      tr
                        th(width="45%")
                          span(:title="$t('ui.date')") {{ $t("ui.date") }}
                        th(width="55%")
                          span(:title="$t('ui.deposit')") {{ $t("ui.deposit") }}
                    tbody
                      tr(v-if="depositList.length == 0")
                        td(colspan="2").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in depositList")
                        td
                          span(:title="$moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss') }}
                        td
                          span(:title="$n(item.amount, 'currency')") {{ $n(item.amount, 'currency') }}
            div.col-sm-12.col-md-3.col-lg-4
              b-form-group(:label="$t('withdrawal')")
                table.tablex(width="100%")
                  thead
                    tr
                      th(width="45%")
                        span(:title="$t('ui.date')") {{ $t("ui.date") }}
                      th(width="55%")
                        span(:title="$t('ui.withdrawal')") {{ $t("ui.withdrawal") }}
                  tbody
                    tr(v-if="withdrawalList.length == 0")
                      td(colspan="2").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in withdrawalList")
                      td
                        span(:title="$moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss') }}
                      td
                        span(:title="$n(item.amount, 'currency')") {{ $n(item.amount, 'currency') }}
            div.col-sm-12.col-md-3.col-lg-4
              b-form-group(:label="$t('login')")
                table.tablex(width="100%")
                  thead
                    tr
                      th(width="45%")
                        span(:title="$t('ui.date')") {{ $t("ui.date") }}
                      th(width="55%")
                        span(:title="$t('ui.login_ip')") {{ $t("ui.login_ip") }}
                  tbody
                    tr(v-if="loginList.length == 0")
                      td(colspan="2").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in loginList")
                      td
                        span(:title="$moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss') }}
                      td
                        span(:title="item.login_ip") {{ item.login_ip }}
      div(slot="modal-ok")
        SubmitButton(:loading="loading" icon="fa fa-check" :text="$t('ui.close')" isModal=true)
      //- div(slot="modal-footer")
      //-   SubmitButton.float-right(icon="far fa-times-circle" :text="$t('ui.close')" @click="closeModal()" size="sm" variant="primary").mr-1
</template>

<script>
import { required, minLength, maxLength, url } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput
  },
  props: {
    item:{
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      loginList: [],
      depositList: [],
      withdrawalList: [],
      validTurnover: null,
      winlose: null,
      feedback: {
        success: true,
        status: ""
      },
    };
  },
  computed: {
    currentMonth() {
      return this.$moment(new Date).format("MMMM");
    }
  },
  mounted: function() {

  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.validTurnover = null;
      this.winlose = null;
      this.loginList = [];
      this.depositList = [];
      this.withdrawalList = [];
      this.getMemberSummary();
    },
    getMemberSummary: function() {
      let url = config.memberSummaryUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.item.account_id,
        working_month: this.$moment(new Date).startOf("month").format("YYYY-MM-DD")
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if(response.data.ds.summary.length > 0) {
                  this.validTurnover = response.data.ds.summary[0].valid_turnover;
                  this.winlose = response.data.ds.summary[0].winlose;
                }

                if(response.data.ds.deposit)
                  this.depositList = response.data.ds.deposit;

                if (response.data.ds.withdrawal)
                  this.withdrawalList = response.data.ds.withdrawal;

                if (response.data.ds.login)
                  this.loginList = response.data.ds.login;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    closeModal: function() {
      this.$refs.memberSummary.hide();
    },
  }
};
</script>
<style lang="scss">
.badge {
  padding: 2.5px 4px !important;
}
.text-value {
  h1 {
    overflow:hidden !important;
    text-overflow:ellipsis !important;
    white-space: nowrap !important;
  }
}
</style>
